<template>
  <div id="newtabs">
    <div class="tab_bottom">
      <div
        v-for="(btn, i) in btns"
        :key="`newtabs_btn_${i}`"
        class="newtabs_btn"
        :class="selectedBtn == btn.v ? 'selected' : ''"
        @click="changeBtn(btn)"
      >
        {{ btn.t }}
      </div>
    </div>
    <div class="line"></div>
    <div class="tab_box">
      <NoticeCC v-if="selectedBtn===btns[1].v" tab-name="gg" />
      <noticeJB v-if="selectedBtn===btns[2].v" />
      <NoticeCC v-if="selectedBtn===btns[3].v" tab-name="jj" />
    </div>
  </div>
</template>
<script>
import NoticeCC from '../notice/NoticeCC'
import noticeJB from '../notice/noticeJB'
export default {
  components: {
    NoticeCC,
    noticeJB
  },
  data() {
    return {
      selectedBtn: 'pk',
      btns: [
        { t: '盘口', v: 'pk' },
        { t: '公告', v: 'gg' },
        { t: '简报', v: 'jb' },
        { t: '简介', v: 'jj' }
        // { t: '明细', v: 'mx' }
      ]
    }
  },
  methods: {
    changeBtn(btn) {
      this.selectedBtn = btn.v
      this.$emit('changTab', btn.v)
    },
    // gotoMX() {
    //   this.$router.push('/TransViewMore')
    // }
  }
}
</script>
<style scoped lang="scss">
#newtabs {
  width: 100%;
  height: 100%;
  .tab_box {
    width: 100%;
    height: calc(100% - 40px);
  }
  .line{
    width: 100%;
    height: 1px;
    background: #1b1d24;
  }
  .tab_bottom {
    background-color:#141517;
    
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    display: flex;
   
    justify-content: space-around;
    align-items: center;
    position: relative;
    border-radius: 4px 4px 0 0;
    border-bottom:1px solid rgba($color: #FFFFFF, $alpha: 0.1) ;
  }
  .newtabs_btn {
    margin: 0 5px;
    width: 42px;
    height: 40px;
    border-radius: 2px;
    // border: 1px solid #cccccc;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #989898;
    line-height: 20px;
    text-align: center;
    cursor: pointer;
    position: relative;
    line-height: 40px;
  }

  .selected:before{
    content: '';
    position: absolute;
    bottom: 0px;
    width: 26px;
    left: 8px;
    right: 10px;
    height: 2px;
    background: rgba($color: #ffffff, $alpha: 0.8);
  }
  .selected{
    color: #dfdfdf;
  }
}
</style>
